import React, { useContext } from 'react'

import { ThemeContext } from '../../../../../../components/ThemeContext'

import HoverTooltip from '../../../../../../components/HoverTooltip'

const TemplatePage: React.FC = () => {
    const { theme } = useContext(ThemeContext)

    return (
        <div className="flex flex-col h-full text-[#181818] dark:text-[#FFFFFF]">
            <div className="bg-[#e5e5e5] dark:bg-[#111111]">
                <div className="w-auto h-20 mx-6 flex flex-row gap-x-5 ">
                    <div className="h-20 my-auto content-center">
                        <p className="text-sm text-[#181818] dark:text-[#FFFFFF]">
                            Шаблоны документов
                        </p>
                    </div>
                </div>
            </div>

            <div className="flex flex-1 justify-center max-h-[calc(100vh_-_80px)] p-5 bg-[#f0f3f5] dark:bg-[#181818]">
                <div className="flex flex-col h-full w-[1260px] space-y-10">
                    {/* // body */}
                    <div className="flex bg-[#f0f3f5] dark:bg-[#181818] h-[calc(100vh_-_120px)]">
                        {/* table */}
                        <div className="flex flex-col h-full w-full">
                            {/* toolbar */}
                            <div className="flex flex-row gap-1 p-2 rounded-t-lg items-center text-[#181818] dark:text-[#FFFFFF] bg-[#d2d5d8] dark:bg-[#333033]">
                                {/* Filter */}
                                <div className="w-6 h-6"></div>
                            </div>

                            {/* name */}
                            <div className="flex flex-row gap-1 h-12 text-[10px] px-2 bg-[#dbdbdb] dark:bg-[#2A282B] text-[#6A6A6A] dark:text-[#8A8A8A]">
                                <div className="flex w-10 h-full items-center justify-center text-center">
                                    №
                                </div>
                                <div className="flex flex-1 h-full items-center justify-center text-center">
                                    Наименование документа
                                </div>
                                <div className="flex flex-col w-[150px] h-full items-center justify-center text-center">
                                    Дата изменения
                                </div>
                                <div className="flex flex-col w-[150px] h-full items-center justify-center text-center">
                                    Размер
                                </div>
                            </div>

                            {/* data */}
                            <div className="flex flex-col gap-1 p-1 h-dvh overflow-y-auto bg-[#e4e6e8] dark:bg-[#1D1C1E] custom-scrollbar">
                                <div className="flex flex-row w-full items-center rounded p-1 text-[11px] text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] hover:bg-[#FFFFFF] dark:bg-[#2A282B] dark:hover:bg-[#373538]">
                                    <div className="flex flex-row w-full h-full py-1">
                                        <div className="flex w-10 items-center justify-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                                            1
                                        </div>

                                        <div className="flex flex-1 w-full items-center truncate pr-2 gap-3">
                                            <HoverTooltip tooltipText="Скачать">
                                                <a
                                                    className="onerow text-[#0284c7] hover:text-[#38bdf8] cursor-pointer"
                                                    href="/docs/template_for_registration.xlsx"
                                                    rel="noopener noreferrer"
                                                >
                                                    Заявка на регистрацию
                                                    пользователей (Шаблон).xlsx
                                                </a>
                                            </HoverTooltip>
                                        </div>
                                        <div className="flex w-[150px] text-left items-center justify-center">
                                            14.01.2025
                                        </div>
                                        <div className="flex flex-row w-[150px] text-left items-center justify-center">
                                            14 KB
                                        </div>
                                    </div>
                                </div>
                                <div className="flex flex-row w-full items-center rounded p-1 text-[11px] text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] hover:bg-[#FFFFFF] dark:bg-[#2A282B] dark:hover:bg-[#373538]">
                                    <div className="flex flex-row w-full h-full py-1">
                                        <div className="flex w-10 items-center justify-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                                            2
                                        </div>

                                        <div className="flex flex-1 w-full items-center truncate pr-2 gap-3">
                                            <HoverTooltip tooltipText="Скачать">
                                                <a
                                                    className="onerow text-[#0284c7] hover:text-[#38bdf8] cursor-pointer"
                                                    href="/docs/template_for_specialist.xlsx"
                                                    rel="noopener noreferrer"
                                                >
                                                    Заявка в план закупки
                                                    (Шаблон для специалиста по
                                                    закупкам).xlsx
                                                </a>
                                            </HoverTooltip>
                                        </div>
                                        <div className="flex w-[150px] text-left items-center justify-center">
                                            14.01.2025
                                        </div>
                                        <div className="flex flex-row w-[150px] text-left items-center justify-center">
                                            62 KB
                                        </div>
                                    </div>
                                </div>
                                <div className="flex flex-row w-full items-center rounded p-1 text-[11px] text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] hover:bg-[#FFFFFF] dark:bg-[#2A282B] dark:hover:bg-[#373538]">
                                    <div className="flex flex-row w-full h-full py-1">
                                        <div className="flex w-10 items-center justify-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                                            3
                                        </div>

                                        <div className="flex flex-1 w-full items-center truncate pr-2 gap-3">
                                            <HoverTooltip tooltipText="Скачать">
                                                <a
                                                    className="onerow text-[#0284c7] hover:text-[#38bdf8] cursor-pointer"
                                                    href="/docs/sample_form_for_specialist.xlsx"
                                                    rel="noopener noreferrer"
                                                >
                                                    Заявка в план закупки
                                                    (Образец заполнения для
                                                    специалиста по
                                                    закупкам).xlsx
                                                </a>
                                            </HoverTooltip>
                                        </div>
                                        <div className="flex w-[150px] text-left items-center justify-center">
                                            14.01.2025
                                        </div>
                                        <div className="flex flex-row w-[150px] text-left items-center justify-center">
                                            63 KB
                                        </div>
                                    </div>
                                </div>
                                <div className="flex flex-row w-full items-center rounded p-1 text-[11px] text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] hover:bg-[#FFFFFF] dark:bg-[#2A282B] dark:hover:bg-[#373538]">
                                    <div className="flex flex-row w-full h-full py-1">
                                        <div className="flex w-10 items-center justify-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                                            4
                                        </div>

                                        <div className="flex flex-1 w-full items-center truncate pr-2 gap-3">
                                            <HoverTooltip tooltipText="Скачать">
                                                <a
                                                    className="onerow text-[#0284c7] hover:text-[#38bdf8] cursor-pointer"
                                                    href="/docs/template_for_initiator.xlsx"
                                                    rel="noopener noreferrer"
                                                >
                                                    Заявка в план закупки
                                                    (Шаблон для инициатора).xlsx
                                                </a>
                                            </HoverTooltip>
                                        </div>
                                        <div className="flex w-[150px] text-left items-center justify-center">
                                            14.01.2025
                                        </div>
                                        <div className="flex flex-row w-[150px] text-left items-center justify-center">
                                            61 KB
                                        </div>
                                    </div>
                                </div>
                                <div className="flex flex-row w-full items-center rounded p-1 text-[11px] text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] hover:bg-[#FFFFFF] dark:bg-[#2A282B] dark:hover:bg-[#373538]">
                                    <div className="flex flex-row w-full h-full py-1">
                                        <div className="flex w-10 items-center justify-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                                            5
                                        </div>

                                        <div className="flex flex-1 w-full items-center truncate pr-2 gap-3">
                                            <HoverTooltip tooltipText="Скачать">
                                                <a
                                                    className="onerow text-[#0284c7] hover:text-[#38bdf8] cursor-pointer"
                                                    href="/docs/sample_form_for_initiator.xlsx"
                                                    rel="noopener noreferrer"
                                                >
                                                    Заявка в план закупки
                                                    (Образец заполнения для
                                                    инициатора).xlsx
                                                </a>
                                            </HoverTooltip>
                                        </div>
                                        <div className="flex w-[150px] text-left items-center justify-center">
                                            14.01.2025
                                        </div>
                                        <div className="flex flex-row w-[150px] text-left items-center justify-center">
                                            64 KB
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* buttons */}
                            <div className="flex flex-row gap-1 p-2 rounded-b-lg h-10 space-x-2 text-[#181818] dark:text-[#FFFFFF] bg-[#d2d5d8] dark:bg-[#333033] "></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TemplatePage
